import {DiReact} from "react-icons/di";
import {FaNodeJs} from "react-icons/fa";
import {SiExpress,SiMongodb} from "react-icons/si";
import { SiFiverr } from "react-icons/si";
import { AiFillGithub,AiFillLinkedin,AiFillYoutube } from "react-icons/ai";
import { CgFigma } from "react-icons/cg";
import { TbBrandReactNative } from "react-icons/tb";
import { SiAdobexd } from "react-icons/si";

export const menu = [
    {name:"About"},
    {name:"Services"},
    {name:"Skill"},
    {name:"Projects"},
    {name:"Testimonial"},
    {name:"Contact"},
]

export const projects = [
    { 
      id:1,
      title: 'Ragnar Servers',
      image: 'https://i.postimg.cc/3RdyrSCv/snapedit-1736771901291.png',
      category:"Channels",
      data:{
         description: `
The Ragnar Servers Telegram channel is a central hub for tech enthusiasts, providing a wide range of high-speed internet configuration files and premium services. This channel offers easy access to configuration files for mobile networks such as Jio, Vi, and Airtel, alongside frequent giveaways for premium services like Crunchyroll and AWS/VPS files. With its direct approach, the channel offers content without the use of shortened links, ensuring a smooth user experience. Whether you're looking for configuration solutions or exclusive giveaways, Ragnar Servers is the place to be!`,
         demoLink: "https://t.me/ragnarservers",
      },
      stack:[]
    },
    {
      id:2,
      title: 'Terabox video streaming web',
      image: 'https://i.postimg.cc/NMVPSswS/IMG-20250113-230548.png',
      category:"Web",
      data:{
        description:`Stream TeraBox videos FAST & EASY! ⚡️ No more tedious downloads, one by one. 🚀 Get your videos instantly with`,
        demoLink: "https://terabox.ragnarservers.workers.dev",
      },
      stack:[]
    },
    {
      id:4,
      title: 'Ana Movies Bot',
      image: 'https://i.postimg.cc/v8cp8919/blade-runner-2049-movies-women-actress-wallpaper-752f63a0a85907e285af2faefca058de-1.jpg',
      category:"Bots",
      data:{
        description: `A Auto filter Movies Bot is an automated tool on the Telegram messaging platform that allows users to search for, request, and download or stream movies directly within the app. These bots typically offer a user-friendly interface where users can enter movie titles or browse categories to find films. Features often include high-quality movie links, genre filters, The convenience and ease of access make Telegram Movies Bots popular among movie enthusiasts looking for quick and free movie options.`,
        demoLink: "https://telegram.me/Moviesnationhubbot",
      },
      stack:[]
    },
    {
      id:5,
      title: 'Ragnar Space',
      image: 'https://i.postimg.cc/Jz4tYM4R/IMG-20250113-223928.png',
      category:"Channels",
      data:{
        description:`The RagnarSpace Telegram channel is your go-to destination for everything related to Telegram bots, tech innovations, and web development. It offers a wealth of information, tutorials, and resources on building and managing Telegram bots, as well as the latest in technology trends, programming guides, and web development tools. Whether you're a developer or a tech enthusiast, RagnarSpace provides the knowledge and community support to help you stay updated in the fast-evolving tech world.`,
        demoLink: "https://t.me/ragnarspace",
      },
      stack:[]
    },
    {
      id:6,
      title: 'File Stream Bot',
      image: 'https://i.postimg.cc/ydTwG4Nz/IMG-20250113-224730.jpg',
      category:"Bots",
      data:{
        description: `File Stream Bot is an automated tool on the Telegram messaging platform that allows users to easily stream or download media files directly within the app. The bot provides high-quality streaming links with multi-player support and direct download options for a seamless user experience. It works efficiently in both private messages and channels, offering a simple interface where users can send media files and instantly receive links for streaming or downloading. With its no-fuss setup and ease of use, File Stream Bot is ideal for those who want quick and convenient access to media content. However, adult and illegal content is strictly prohibited.`,
        demoLink: "https://github.com/codeflix-bots/FileStream_TGBot",
      },
      stack:[]
    },
  ]

export const experience = [
    {
        title:"Channels",
        data:[
            {
                skill:"Figma",
                level:"Experienced",
            },
            {
                skill:"Sketch",
                level:"Intermediate",
            },
            {
                skill:"XD",
                level:"Intermediate",
            },
        ]
    },
]

export const socialHandles = [
  {
    name:"Fiverr",
    icon:<SiFiverr/>,
    link:"",
  },
  {
    name:"Github",
    icon:<AiFillGithub/>,
    link:"github.com/AnimeHolic",
  },
  {
    name:"LinkedIn",
    icon:<AiFillLinkedin/>,
    link:"",
  },
  {
    name:"Youtube",
    icon:<AiFillYoutube/>,
    link:"www.youtube.com/@RagnarServers",
  },
];
